import { Fragment, PureComponent, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router-dom';
import LabStartPage from './LabStartPage';
import PharmaStartPage from './PharmaStartPage';

const PHARMA = 'pharma';
const LAB = 'lab';

const START = 'start';
const FINISH = 'finish';

export type TrialOrderType = typeof PHARMA | typeof LAB;
export type TrialOrderState = typeof START | typeof FINISH;

type RouterProps = {
    type: TrialOrderType;
    state: TrialOrderState;
};

type Props = RouteComponentProps<RouterProps>;

interface State {
    isFetchingProfile?: boolean;
}

class TrialOrderHomePage extends PureComponent<Props, State> {
    renderRightPanel = (): JSX.Element | undefined => {
        const { match } = this.props;
        const { type } = match.params;

        switch (type) {
            case 'pharma':
                return <PharmaStartPage />;
            case 'lab':
                return <LabStartPage />;
        }
    };

    render(): ReactNode {
        const { renderRightPanel } = this;
        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EKA - HE Onboarding</title>
                </Helmet>

                <div className="h-screen w-screen min-w-840">{renderRightPanel()}</div>
            </Fragment>
        );
    }
}

export default TrialOrderHomePage;
